import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'Para quem é esse curso?',
      answer: 'Para jovens de 8 a 17 anos que não veem sentido nas matérias da escola tradicional, entendem que ela não os prepara para a vida real e querem sair na frente, aprender as habilidades do futuro e ganhar dinheiro muito antes dos outros sequer entrarem na faculdade.'
    },
    {
      question: 'Meu filho realmente precisa disso? Não é só mais um curso?',
      answer: 'O Freedom Experience não é "mais um curso"; é uma imersão única, disruptiva e sem concorrentes, criada para ensinar as habilidades mais importantes do futuro — aquelas que a escola tradicional não ensina: IA, Bitcoin, dinheiro, comunicação, estratégia, projeto de vida, mente forte, memória, xadrez e muito mais. Se o seu filho quer se destacar, pensar diferente e construir um futuro brilhante, este é o caminho.'
    },
    {
      question: 'Qual a faixa etária recomendada?',
      answer: 'De 8 a 17 anos.'
    },
    {
      question: 'O conteúdo não é avançado demais para crianças e adolescentes?',
      answer: 'Não. O curso foi projetado para que qualquer jovem, independente do nível atual, aprenda de forma leve, prática e divertida. As aulas estimulam curiosidade, criatividade e protagonismo, sem pressão e com explicações acessíveis. Além disso, jovens têm muito mais facilidade de aprender certos conteúdos do que adultos, e eles vão amar.'
    },
    {
      question: 'O curso é online ou presencial?',
      answer: 'O curso é 100% presencial, em Teresina.'
    },
    {
      question: 'Qual é a data do curso?',
      answer: 'O Freedom Experience é um curso de férias com duas turmas: uma no início de dezembro e outra no início de janeiro.'
    },
    {
      question: 'Qual é o horário das aulas?',
      answer: 'As aulas acontecem das 8h às 12h durante 3 semanas. A estrutura diária é: primeira aula das 8h às 9h, segunda das 9h30 às 10h30 e terceira das 11h às 12h. Se o aluno fizer o curso integral, terá aulas todos os dias; se fizer apenas cursos específicos, geralmente serão duas aulas por semana no horário de cada módulo.'
    },
    {
      question: 'Qual é a duração total e como funciona a estrutura?',
      answer: 'O curso integral dura 3 semanas e possui mais de 50 horas de aulas. Já os módulos individuais possuem, em geral, carga horária entre 4 e 6 horas, dependendo do curso escolhido.'
    },
    {
      question: 'As turmas são divididas por idade?',
      answer: 'Não. Crianças de 8 anos estudam junto com adolescentes de 17, pois a mistura de idades faz parte do nosso método inovador, onde os alunos aprendem uns com os outros, como acontece no mundo real.'
    },
    {
      question: 'Meu filho precisa de conhecimentos prévios?',
      answer: 'Não. O curso foi criado para ser acessível, envolvente e prático, permitindo que qualquer aluno acompanhe facilmente, mesmo em temas mais complexos, que são explicados de forma simples e inspiradora.'
    },
    {
      question: 'A criança precisa de materiais ou equipamentos especiais?',
      answer: 'Sim. Cada aluno deve trazer seu notebook, que é essencial para as atividades. Se tiver celular, fone de ouvido ou iPad, também pode trazer, mas o único item obrigatório é o notebook.'
    },
    {
      question: 'Posso me inscrever apenas em um curso ou preciso fazer o programa completo?',
      answer: 'Você pode escolher fazer apenas o módulo que mais interessar ao seu filho ou optar pela matrícula integral e aprender todas as 9 habilidades do futuro, que se complementam entre si.'
    },
    {
      question: 'Como funcionam os cursos bônus? Posso comprar separadamente?',
      answer: 'Os cursos bônus não são vendidos separadamente; eles são exclusivos para quem faz o curso integral.'
    },
    {
      question: 'Quanto custa o curso e quais são as formas de pagamento?',
      answer: 'O valor atual e todas as modalidades (à vista, parcelado, bônus etc.) estão disponíveis na página de inscrição.'
    },
    {
      question: 'Como faço a inscrição?',
      answer: 'Clique no botão de compra, envie um WhatsApp informando se deseja o curso completo ou apenas um módulo específico, e nossa equipe fará sua matrícula.'
    },
    {
      question: 'Posso matricular mais de um filho? Há desconto para famílias?',
      answer: 'Sim. Muitos pais matriculam dois ou mais filhos. Entre em contato para verificar se há alguma condição especial ou desconto familiar.'
    },
    {
      question: 'Posso colocar meu filho em apenas um módulo?',
      answer: 'Sim. O Freedom Experience é um programa completo, mas flexível — você pode matricular seu filho apenas nos módulos que fizerem mais sentido para ele.'
    },
    {
      question: 'Isso realmente prepara para o futuro? Ou é só hype?',
      answer: 'Nada aqui é hype. Cada tema foi escolhido porque são habilidades que valem dinheiro hoje e valerão ainda mais nos próximos 10 anos. IA, Bitcoin, comunicação, estratégia, criatividade e projeto de vida são competências que diferenciam os adultos bem-sucedidos, e o Freedom Experience desenvolve essa base desde cedo.'
    },
    {
      question: '5 mil reais não é caro? Vale o investimento?',
      answer: 'O Freedom Experience não é um custo; é um investimento no futuro do seu filho. Enquanto escolas tradicionais cobram de 3 a 5 mil reais por mês para ensinar conteúdos ultrapassados e irrelevantes, aqui ele aprende habilidades que realmente definem a vida adulta. Os 5.000 reais equivalem a uma única mensalidade de uma escola tradicional de alto padrão — e nenhuma ensina esse conteúdo.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="relative py-16 md:py-32 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 right-1/4 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-neon-purple/20 rounded-full blur-[100px] md:blur-[150px] animate-pulse-slow"></div>
      <div className="absolute bottom-0 left-1/4 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-neon-blue/20 rounded-full blur-[100px] md:blur-[150px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-16 space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-neon-purple/10 border border-neon-purple/30 backdrop-blur-sm">
              <i className="ri-question-line text-neon-purple text-sm md:text-base"></i>
              <span className="text-neon-purple text-xs md:text-sm font-semibold tracking-wide">DÚVIDAS FREQUENTES</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight px-4">
              Perguntas
              <span className="block bg-gradient-to-r from-neon-blue to-neon-purple bg-clip-text text-transparent mt-2">Frequentes</span>
            </h2>
          </div>

          {/* FAQ List */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-dark-800/60 backdrop-blur-xl border border-neon-blue/30 rounded-xl md:rounded-2xl overflow-hidden transition-all duration-300 hover:border-neon-blue/50"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-5 md:px-8 py-5 md:py-6 flex items-center justify-between gap-4 text-left cursor-pointer group"
                >
                  <span className="text-white font-semibold text-base md:text-lg lg:text-xl flex-1 group-hover:text-neon-blue transition-colors duration-300">
                    {faq.question}
                  </span>
                  <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`${
                        openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                      } text-2xl md:text-3xl text-neon-blue transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 md:px-8 pb-5 md:pb-6 pt-0">
                    <div className="border-t border-neon-blue/20 pt-4 md:pt-5">
                      <p className="text-gray-300 text-sm md:text-base lg:text-lg leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-10 md:mt-16 text-center">
            <div className="bg-gradient-to-r from-neon-blue/10 to-neon-purple/10 border border-neon-blue/30 rounded-xl md:rounded-2xl p-6 md:p-8">
              <p className="text-white text-lg md:text-xl lg:text-2xl font-semibold mb-4 md:mb-6">
                Ainda tem dúvidas?
              </p>
              <button
                onClick={() => window.open('https://wa.me/5586988088824?text=Olá! Tenho dúvidas sobre o Freedom Experience', '_blank')}
                className="inline-flex items-center gap-2 md:gap-3 px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-neon-blue to-neon-purple rounded-xl font-bold text-base md:text-lg text-white hover:scale-105 transition-all duration-300 hover:shadow-[0_0_40px_rgba(0,212,255,0.6)] whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl"></i>
                Fale Conosco no WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
